import { getPropSafely, isStringEmpty } from "@/utils/utils"
import styled from "styled-components"
import Image, { formatImageCMSData } from "@/components/common/Image"
import { ICONS } from "@/constants"
import { colors } from "@/styles/themeSettings"
import SimpleIconButton, { SIMPLE_ICON_BUTTON_CLASS_NAME } from "@/components/common/SimpleIconButton"
import useHover from "@/hooks/useHover"
import { useEffect } from "react"
import useGlobals from "@/hooks/useGlobals"

const ImageHeaderWrapper = styled.div`
	cursor: pointer;
	width: 100%;
	height: auto;
`

const StyledImageWrapper = styled.div`
	overflow: hidden;
	position: relative;

	&.border {
		border: 1px solid ${({ theme }) => theme.colors.richBlue};
	}

	.${SIMPLE_ICON_BUTTON_CLASS_NAME} {
		position: absolute;
		z-index: 2;
		top: 0;
		right: 0;
	}
`

const StyledImage = styled(Image)`
	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16/9"};
	width: 100%;
	height: auto;
	transition: all var(--rgr-duration) var(--ease);

	&.hover {
		transform: scale(1.1);
	}
`

const ImageContent = ({ data, hoveredId, setHoveredId, handleDownload }) => {
	const id = getPropSafely(data, "id")
	const image = formatImageCMSData(getPropSafely(data, "coverImage", {}))
	const border = getPropSafely(data, "border", false)

	const [ref, hovering] = useHover({
		onMouseLeaveCallback: () => {
			setHoveredId(null)
		},
	})

	useEffect(() => {
		if (!hovering) return
		setHoveredId(id)
	}, [hovering])

	const hoverClassName = hoveredId === id ? "hover" : ""

	const fileTileCoverBackup = useGlobals((state) => state.fileTileCoverImage)
	const finalImage = !isStringEmpty(image.url) ? image : formatImageCMSData(fileTileCoverBackup || {})

	return (
		<>
			<ImageHeaderWrapper ref={ref} className="image-header-wrapper col-mobile-8 col-tablet-4 col-desktop-4" onClick={handleDownload}>
				{!isStringEmpty(finalImage.url) && (
					<StyledImageWrapper className={`${border ? "border" : ""}`}>
						<SimpleIconButton name={ICONS.DOWNLOAD} bgColor={colors.chilliRed} borderColor={colors.chilliRed} />
						<StyledImage
							src={finalImage.url}
							alt={finalImage.alt}
							$aspectRatio={finalImage.aspectRatio}
							className={hoverClassName}
						/>
					</StyledImageWrapper>
				)}
			</ImageHeaderWrapper>
		</>
	)
}

export default ImageContent
